import { forwardRef, HTMLAttributes, PropsWithChildren, useContext } from 'react';

import FieldsetContext from '../context';

import s from './FieldsetError.module.scss';

export type FieldsetErrorProps = HTMLAttributes<HTMLParagraphElement>;

const FieldsetError = forwardRef<HTMLParagraphElement, PropsWithChildren<FieldsetErrorProps>>((props, ref) => {
  const FieldsetHelpContext = useContext(FieldsetContext);

  if (!FieldsetHelpContext?.isInvalid) return null;

  return <p className={s.text} {...props} ref={ref} />;
});

export default FieldsetError;
